import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { renewPoints } from 'shared/store/kingdom/points'
import { colors } from 'shared/assets/styles'
import { SmallText } from 'app/common/typography'
import { FormattedMessage } from 'react-intl'
import { Loader } from 'app/common/loader'
import styled from 'styled-components'
import { AlertModal } from 'app/common/modals/alert'

type Props = {
    handleClose: () => void
}

const RenewPointsModal = (props: Props) => {
    const [state, setState] = useState({ error: false, loading: false })
    const dispatch = useDispatch()

    const { handleClose } = props
    const { error, loading } = state

    const handleRenewPoints = async () => {
        setState({ ...state, error: false, loading: true })
        const success = await dispatch(renewPoints())
        setState({ ...state, error: !success, loading: false })
        if (success) {
            handleClose()
        }
    }

    return (
        <AlertModal
            isOpen={true}
            alertTitleKey="kingdom.points.renew.modal.title"
            handleClose={handleClose}
            okLabel="form.button.valid"
            leftLabel="form.button.cancel"
            onOkClick={handleRenewPoints}
            onLeftClick={handleClose}
            disabled={loading}>
            <LoaderContainer>
                {error && (
                    <SmallText color={colors.error}>
                        <FormattedMessage id="form.error.default" />
                    </SmallText>
                )}
                <Loader loading={loading} style={{ flex: 1 }} />
            </LoaderContainer>
        </AlertModal>
    )
}

const LoaderContainer = styled.div`
    min-height: 20px;
`

export { RenewPointsModal }
